// extracted by mini-css-extract-plugin
export var dividerLine = "_5o-3";
export var itemImage = "_5o-9";
export var lightDivider = "_5o-4";
export var modalContent = "_5o-5";
export var modalContentCompact = "_5o-6";
export var productCard = "_5o-a";
export var productImage = "_5o-b";
export var productImageCompact = "_5o-7";
export var productImagePlaceholder = "_5o-c";
export var productImagePlaceholderCompact = "_5o-8";
export var progressBarBackground = "_5o-1";
export var progressBarContainer = "_5o-0";
export var progressBarFill = "_5o-2";